import React from 'react';

// Shared loading / error feedback for sections that fetch from Firestore.
// `status` is one of: 'loading' | 'slow' | 'ready' | 'error'.

export const LoadingNotice = ({ label, slow = false, onRetry }) => (
  <div role="status" className="flex flex-col items-start gap-2 py-6">
    <div className="flex items-center gap-3">
      <div className="h-4 w-4 rounded-full border-2 border-sky-400/25 border-t-sky-400 motion-safe:animate-spin" aria-hidden="true"></div>
      <p className="text-sm text-slate-400">Loading {label}...</p>
    </div>
    {slow && (
      <p className="text-sm text-slate-400">
        This is taking longer than usual.{' '}
        {onRetry && (
          <button
            onClick={onRetry}
            className="text-link"
          >
            Try again
          </button>
        )}
      </p>
    )}
  </div>
);

export const LoadError = ({ label, onRetry }) => (
  <div
    role="alert"
    className="flex flex-col items-start gap-3 rounded-xl bg-red-500/10 p-4 text-red-200 ring-1 ring-inset ring-red-400/30 sm:flex-row sm:items-center sm:justify-between"
  >
    <p>Couldn't load {label}. Check your connection and try again.</p>
    {onRetry && (
      <button
        onClick={onRetry}
        className="btn-secondary px-4 py-2"
      >
        Try again
      </button>
    )}
  </div>
);

export const isPending = (status) => status === 'loading' || status === 'slow';
